import styled, { css } from 'styled-components'
import { StyledParagraph, StyledTag } from 'components/shared'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

export const Wrapper = styled.div`
  ${({ theme }) => css`
    overflow-y: auto;
    overflow-x: hidden;
    height: inherit;
    width: 260px;
    min-width: 260px;
    padding: 24px 16px 16px 24px;
    border-right: 1px solid ${theme.colors.greyLight};
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (min-height: 680px) {
      padding: 40px 16px 16px 24px;
    }
  `}
`

export const TaskDataList = styled.div`
  ${() => css`
    margin: 0 8px 24px 0;

    @media (min-height: 680px) {
      margin: 0 8px 40px 0;
    }
  `}
`

export const TaskAction = styled.div`
  margin-top: auto;
`

export const TaskData = styled.div`
  ${({ theme }) => css`
    margin-bottom: 32px;

    @media (min-height: 680px) {
      margin-bottom: 40px;
    }

    label {
      font-weight: 500;
      letter-spacing: 1px;
      font-size: 9px;
      line-height: 10px;
      display: block;
      text-transform: uppercase;
      color: ${theme.colors.greySemiDark};
      margin-bottom: 8px;
    }

    a {
      text-decoration: underline;
      display: inline-block;

      &:hover {
        text-decoration: none;
      }
    }

    .Avatar__root {
      min-height: 42px;
      margin-bottom: 12px;

      &:last-of-type {
        margin-bottom: 0;
      }

      .grey {
        color: ${theme.colors.greySemiDark};
      }
    }

    ${StyledTag} {
      margin-left: -8px;
    }

    ${StyledParagraph} {
      word-break: break-word;
    }
  `}
`

export const TagButton = styled.div<{ clickable: boolean }>`
  ${({ clickable }) => css`
    cursor: ${clickable ? 'pointer' : 'default'};
    // safari fix
    margin-left: -8px;
    padding-left: 8px;
    overflow: visible;
  `}
`

export const TaskNotice = styled.div`
  ${({ theme }) => css`
    bottom: 0;
    position: fixed;
    align-items: center;
    background: ${theme.colors.black};
    color: ${theme.colors.white};
    fill: ${theme.colors.white};
    padding: 16px;
    border-radius: 16px;
    margin-bottom: 8px;
    z-index: 100;
  `}
`

export const useDropdownStyles = makeStyles(theme =>
  createStyles({
    paper: {
      borderRadius: 12,
      boxShadow:
        '0px 40px 80px rgba(173, 173, 173, 0.07), 0px 20px 33.4221px rgba(173, 173, 173, 0.0503198), 0px 10px 17.869px rgba(173, 173, 173, 0.0417275), 0px 4px 10.0172px rgba(173, 173, 173, 0.035), 0px 2px 5.32008px rgba(173, 173, 173, 0.0282725), 0px 0px 2.21381px rgba(173, 173, 173, 0.0196802)',
      color: theme.colors.black,

      '& .MuiMenuItem-root': {
        fontSize: 12,
        minHeight: 34,

        '&:hover': {
          background: theme.colors.greyLight,
        },
      },
    },
    menuItem: {
      backgroundColor: ({ isSubMenuOpen }: { isSubMenuOpen?: boolean }) =>
        isSubMenuOpen ? theme.palette.action.hover : 'transparent',
    },
  })
)
